// Raw hex values mirroring tailwind.config.js's rf- tokens. Recharts renders
// raw SVG, which can't be styled with Tailwind class names — this is the one
// authoritative place those tokens get duplicated as hex for chart code.
export const chartColors = {
  bgSecondary: "#151b2e",
  bgTertiary: "#1e2840",
  grid: "#1e2840",
  textPrimary: "#e8ecf3",
  textSecondary: "#8b95ab",
  textMuted: "#4a5568",
  accent: "#00d4aa",
  blue: "#0099ff",
  danger: "#ff4757",
  warning: "#ffa502",
  purple: "#a855f7",
};

export const chartFonts = {
  mono: "'JetBrains Mono', monospace",
  sans: "'DM Sans', -apple-system, sans-serif",
};

// Shared axis/grid props so every chart in the analytics page reads as one
// visual system. Horizontal-only gridlines — vertical lines on an OLED-dark
// chart turn it into graph paper.
export const sharedCartesianGridProps = {
  stroke: chartColors.grid,
  vertical: false,
};

export const sharedAxisProps = {
  stroke: chartColors.textMuted,
  tick: { fill: chartColors.textSecondary, fontSize: 11, fontFamily: chartFonts.mono },
  tickLine: false,
  axisLine: { stroke: chartColors.grid },
};

// Re-exported, no longer copied. This used to be a verbatim duplicate of
// TeamPanel.js's thresholds with a comment admitting as much; both now read
// from utils/reviewLoad.js so the same reviewer cannot be "busy" orange on
// the dashboard and teal in this chart.
export { loadColor } from "../../utils/reviewLoad";

// priority color map copied verbatim from PrCard.js's priorityConfig, for
// the aging-PR table's priority badges.
export const priorityColors = {
  critical: chartColors.danger,
  high: chartColors.warning,
  medium: chartColors.blue,
  low: chartColors.accent,
};
